
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/decentralized-finance-defi-development",
      function () {
        return require("private-next-pages/decentralized-finance-defi-development/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/decentralized-finance-defi-development"])
      });
    }
  